import { Form, Select } from 'antd';

import { PictureComponent } from 'app/components/commons/PictureComponent/PictureComponent';
import { usePackages } from 'app/hooks/data/packages/usePackages';
import { formatPackageName } from 'app/utils/packages';
import { requiredRule } from 'app/utils/rules';

import { HeaderWrapper } from '../../../../HeaderWrapper/HeaderWrapper';

const { Option } = Select;

type Props = {
  fieldName: string | number;
};

export const PageRedirectionForm = ({ fieldName }: Props) => {
  const { data: packages } = usePackages();

  return (
    <div className="actionContainer">
      <div className="arrow" />
      <HeaderWrapper title="Package">
        <Form.Item name={[fieldName, 'packageId']} rules={[requiredRule]}>
          <Select
            showSearch
            optionFilterProp="children"
            placeholder="Select a package from the list"
            filterOption={(input, option) =>
              option?.props.key
                .toLowerCase()
                .toString()
                .includes(input.toLowerCase())
            }
          >
            {packages?.map((data) => (
              <Option
                key={`${data.hotelName}-${data.id}`}
                value={data.id}
                className="select-item__option"
              >
                <div className="select-item__wrapper">
                  <div className="select-item__thumbnail">
                    <PictureComponent {...data.coverPicture} />
                  </div>
                  <div className="select-item__name">
                    {formatPackageName({
                      name: data.aliasForHotel,
                      hotelName: data.hotelName,
                    })}
                  </div>
                </div>
              </Option>
            ))}
          </Select>
        </Form.Item>
      </HeaderWrapper>
    </div>
  );
};
